import { render } from "./SidebarChild.vue?vue&type=template&id=046e2269&scoped=true"
import script from "./SidebarChild.vue?vue&type=script&lang=js"
export * from "./SidebarChild.vue?vue&type=script&lang=js"

import "./SidebarChild.vue?vue&type=style&index=0&id=046e2269&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046e2269"]])

export default __exports__